import { create } from 'zustand';

export const useSocketStore = create((set) => ({
  receivedPersonalMessage: null,
  receivedGroupMessage: null,
  receivedSystemMessage: null,
  sendPrivateMessage: null,
  sendGroupMessage: null,
  sendSystemMessage: null,

  setPersonalMessage: (msg) =>
    set(() => ({
      receivedPersonalMessage: msg,
    })),

  setGroupMessage: (msg) =>
    set(() => ({
      receivedGroupMessage: msg,
    })),

  setSystemMessage: (msg) =>
    set(() => ({
      receivedSystemMessage: msg,
    })),

  setSendPrivateMessage: (fn) => set({ sendPrivateMessage: fn }),
  setSendGroupMessage: (fn) => set({ sendGroupMessage: fn }),
  setSendSystemMessage: (fn) => set({ sendSystemMessage: fn }),
}));
